const theme = {
    colors: {
      white: '#FFFFFF',
      black: '#000000',
      blue: "#0066af",
    },
    sizes: {
      mobile: "767px",
      tablet: "992px",
      aboveTablet: "993px",
      aboveLargeTablet: "1024px",
      desktop: "1200px",
      largeDesktop: "1440px"
    }
  };
  
  export default theme;